import { defineStore } from 'pinia'
import i18n from '../i18n'
import API from '../api/axios'

function safeParse(key: string, fallback: any = []) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback // null, empty string
    return JSON.parse(raw)
  } catch (e) {
    console.warn(`Invalid JSON in localStorage for key "${key}"`, e)
    return fallback
  }
}

export const useMiscStore = defineStore('misc', {
  state: () => {
    return {
      // initialize state from local storage to enable user to stay logged in
      currentTitle: safeParse('currentItem', {}),
      currentUrl: '/',
      activenav: 'home',
      currentLang: localStorage.getItem('currentLang') || 'gb',
      lastPage: localStorage.getItem('lastPage') || '/',
      resources: safeParse('resources', []),
      categories: safeParse('categories', []),
    }
  },
  getters: {
    currentUrl: (state) => state.currentUrl,
    currentTitle: (state) => state.currentTitle,
  },
  actions: {
    async miscSetUrl(url: string) {
      this.currentUrl = url
    },
    async miscSetLang(lang: string) {
      localStorage.setItem('currentLang', lang)
      this.currentLang = lang
      // update global i18n locale so UI reacts immediately
      //const { locale } = useI18n({ useScope: 'global' })
      // update the global i18n locale directly
      if (i18n && i18n.global) {
        i18n.global.locale.value = lang
      }
      //locale.value = lang
    },
    async miscSetActiveNav(nav: string) {
      this.activenav = nav
    },
    async miscSetTile(title: string) {
      this.currentTitle = title
    },
    async miscSetLastPage(url: string) {
      localStorage.setItem('lastPage', url)
      this.lastPage = url
    },
    async miscGetResources() {
      if (localStorage.getItem('resources')) return true
      try {
        const resp = await API.get('/v1/users/getresources')
        //console.log("resources:", resp)
        this.resources = resp.data.resources
        localStorage.setItem('resources', JSON.stringify(this.resources))
        return resp
      } catch (error: any) {
        console.log('ERROR ', error.message)
        return { Error: error.message }
      }
    },
    async miscGetCategories() {
      if (localStorage.getItem('categories')) return true
      try {
        const resp = await API.get('/v1/categories/shortlist')
        console.log(resp)
        this.categories = resp.data.categories
        localStorage.setItem('categories', JSON.stringify(this.categories))
        return resp
      } catch (error: any) {
        console.error('ERROR ', error.message)
        return { Error: error.message }
      }
    },
  },
})
